export const FilingStatus = {
    REJECTED: "REJECTED",
    REJECT: "REJECT",
    ERROR: "ERROR",
    IN_PROGRESS: "IN_PROGRESS",
    MAILEDIN: "MAILEDIN",
    PAPERFILED: "PAPERFILED",
    NETFILED: "NETFILED",
    REFILED: "REFILED",
    FILED: "FILED",
    SUCCESS: "SUCCESS"
}

export const RefileDashboardStatii = [
    'REFILECRA',
    'REFILEMRQ',
    'REFILET1135',
    'EFILE',
    'EFILEMRQ',
    'EFILET1135',
    'REFILED'
]